import React from 'react';
import { Link } from 'react-router-dom';
import { Activity, Twitter, Linkedin, Github } from 'lucide-react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container footer-content">
                <div className="footer-brand">
                    <Link to="/" className="logo">
                        <Activity className="logo-icon" size={24} />
                        <span className="logo-text">OEESuite</span>
                    </Link>
                    <p className="footer-desc">
                        Empowering manufacturing with real-time Overall Equipment Effectiveness analytics. Maximize your production floor potential.
                    </p>
                </div>
                <div className="footer-links-group">
                    <h4 className="footer-title">Company</h4>
                    <Link to="/about">About Us</Link>
                    <Link to="/">Careers</Link>
                    <Link to="/">Contact</Link>
                </div>
                <div className="footer-links-group">
                    <h4 className="footer-title">Products</h4>
                    <Link to="/">OEE Dashboard</Link>
                    <Link to="/">Downtime Tracker</Link>
                    <Link to="/">Quality Analytics</Link>
                </div>
                <div className="footer-social">
                    <h4 className="footer-title">Connect</h4>
                    <div className="social-icons">
                        <a href="#" className="social-icon"><Twitter size={20} /></a>
                        <a href="#" className="social-icon"><Linkedin size={20} /></a>
                        <a href="#" className="social-icon"><Github size={20} /></a>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} OEESuite. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
